if (!customElements.get('toggle-cross-sell')) {
  customElements.define(
    'toggle-cross-sell',

    class ToggleCrossSell extends HTMLElement {
      constructor() {
        super();

        this.main_product_form =
          this.closest('.product').querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (this.main_product_form === null) return console.error('ToggleCrossSell: No product form found');
      }

      connectedCallback() {
        // Si on clique autour bouton ou de la checkbox, on veut quand même toggle le cross-sell
        this.addEventListener('click', this.onToggleProduct.bind(this));
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          // On écoute les changement de variante
          if (product.querySelector('select') != null) {
            product.querySelector('select').addEventListener('change', this.variantChanged.bind(this, product));
          }
          // On écoute les clics sur le bouton d'ajout
          if (product.querySelector('.button') != null) {
            product
              .querySelector('.button')
              .addEventListener('click', this.toggleAddButton.bind(this, product.querySelector('.button')));
          }
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onToggleProduct.bind(this));
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          if (product.querySelector('select') != null) {
            product.querySelector('select').removeEventListener('change', this.variantChanged.bind(this, product));
          }
          if (product.querySelector('.button') != null) {
            product
              .querySelector('.button')
              .removeEventListener('click', this.toggleAddButton.bind(this, product.querySelector('.button')));
          }
        });
      }

      // Change l'état du bouton d'ajout
      toggleAddButton(button, active) {
        if (button.classList.contains('button--secondary') || active == true) {
          button.classList.add('button--active');
          button.classList.remove('button--secondary');
        } else {
          button.classList.remove('button--active');
          button.classList.add('button--secondary');
        }
      }

      onToggleProduct(event) {
        const checkbox = event.target.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = !checkbox.checked;
        const button_add = event.target.querySelector('.button');
        if (button_add) this.toggleAddButton(button_add);
        this.updateMainFormInputs();
      }

      variantChanged(product) {
        const select = product.querySelector('select');
        const optionSelected = select.options[select.selectedIndex];
        this.updateProductPrice(product, optionSelected);
        this.updateProductImage(product, optionSelected);
        this.updateVariantId(product, optionSelected);
      }

      updateProductPrice(product, optionSelected) {
        const variantPrice = optionSelected.dataset.price;
        const compareAtPrice = product.querySelector('.toggle-cross-sell__product-compare-at-price');
        const badgeDiscount = product.querySelector('.toggle-cross-sell__product-badge-discount');
        product.querySelector('.toggle-cross-sell__product-price').innerHTML = variantPrice;

        if (optionSelected.dataset.compareAtPrice != null) {
          if (badgeDiscount != null) {
            compareAtPrice.innerHTML = optionSelected.dataset.compareAtPrice;
            compareAtPrice.style.display = 'block';
          }
          if (badgeDiscount != null) {
            badgeDiscount.innerHTML = optionSelected.dataset.discountText;
            badgeDiscount.style.display = 'flex';
          }
        } else {
          if (badgeDiscount != null) compareAtPrice.style.display = 'none';
          if (badgeDiscount != null) badgeDiscount.style.display = 'none';
        }
      }

      updateProductImage(product, optionSelected) {
        if (
          optionSelected.dataset.variantImage != null &&
          product.querySelector('.toggle-cross-sell__product-image') != null
        ) {
          const variantImage = optionSelected.dataset.variantImage;
          product.querySelector('.toggle-cross-sell__product-image img').src = variantImage;
        }
      }

      updateVariantId(product, optionSelected) {
        const variantId = optionSelected.value;
        const checkbox = product.querySelector('input[type="checkbox"]');
        const button_add = product.querySelector('.button');
        if (checkbox != null) {
          checkbox.dataset.variantId = variantId;
          checkbox.checked = true;
        }
        if (button_add != null) {
          button_add.dataset.variantId = variantId;
          this.toggleAddButton(button_add, true);
        }
        this.updateMainFormInputs();
      }

      resetMainFormInputs() {
        this.main_product_form.querySelectorAll('.from-toggle-cross-sell').forEach((input) => input.remove());
      }

      updateMainFormInputs() {
        this.resetMainFormInputs();

        this.querySelectorAll('.toggle-cross-sell__product').forEach((product, index) => {
          const checkbox = product.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            this.main_product_form.insertAdjacentHTML(
              'beforeend',
              `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${checkbox.dataset.variantId}">`,
            );
          }

          const button_add = product.querySelector('.button');
          if (button_add && button_add.classList.contains('button--active')) {
            this.main_product_form.insertAdjacentHTML(
              'beforeend',
              `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${button_add.dataset.variantId}">`,
            );
          }
        });
      }
    },
  );
  // === Visibility toggle for Cross-sell on "Creator Kit" and "Premium Kit" ===
(function () {
  // 1) Trouve le bloc <toggle-cross-sell>
  const allCrossSells = Array.from(document.querySelectorAll('toggle-cross-sell'));
  if (!allCrossSells.length) return;

  const target = allCrossSells.find(el => /Adaptateur mini-jack/i.test(el.textContent)) || allCrossSells[0];

  // 2) Récupère l'input "id"
  const idInput =
    target.closest('.product')?.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (!idInput) return;

  // 3) Tes IDs
  const CREATOR_IDS = ['50535026753878', '52558118814038']; 

  // 4) LA CORRECTION : On accepte les deux noms !
  const TRIGGER_TEXTS = ['creator kit', 'premium kit'];

  function isCreatorKit() {
    const curId = String(idInput.value || '');
    if (curId && CREATOR_IDS.length && CREATOR_IDS.includes(curId)) return true;

    // Fallback 1 : Sélecteur natif
    const opt = document.querySelector('select[name="id"] option:checked');
    if (opt?.textContent) {
        const text = opt.textContent.toLowerCase();
        if (TRIGGER_TEXTS.some(t => text.includes(t))) return true;
    }

    // Fallback 2 : Ton nouveau design de variante cliquable
    const activeTitle = document.querySelector('.bundle-title--selected');
    if (activeTitle) {
        const text = activeTitle.textContent.toLowerCase();
        if (TRIGGER_TEXTS.some(t => text.includes(t))) return true;
    }

    return false;
  }

 function render() {
    var hasBundleSelector = document.querySelector('.bundle-option') || document.querySelector('select[name="id"]');
    if (!hasBundleSelector) {
      target.style.display = '';
      return;
    }
    target.style.display = isCreatorKit() ? '' : 'none';
  }

  // Init
  render();

  // 5) Écouteurs d'événements blindés
  idInput.addEventListener('change', render);
  document.addEventListener('change', (e) => {
    if (e.target.matches('select[name="id"], [name^="options"], #nativeVariantInput')) render();
  });

  // ---> NOUVEAU : Force la vérification quand on clique sur tes blocs de variantes visuels
  document.querySelectorAll('.bundle-option').forEach(el => {
    el.addEventListener('click', () => {
        setTimeout(render, 50); // Laisse le temps à l'input de se mettre à jour
    });
  });

  ['variant:changed','product:variant-change','theme:variant:change'].forEach(ev =>
    document.addEventListener(ev, render)
  );

  new MutationObserver(render).observe(idInput, { attributes: true, attributeFilter: ['value'] });
})();

}